import {Component} from '@angular/core';
import {
	EntitySelectComponent,
	BaseModel,
	BaseModelInterface,
} from '@app/abstracts';
import {ErrorService} from '@app/services';
import {AboutSearchParams} from '../about-search-params';
import {AboutService} from '../about.service';
import {About} from '../about';
import { QuickFormService } from '../../../plugins/quick-form';
@Component({
  selector: 'hpf-about-select',
  templateUrl: '../../../abstracts/entity-select/entity-select.component.html'
})
export class AboutSelectComponent extends EntitySelectComponent< About> {
  protected modelName = 'about';
  /**
   * Constructor
   * @param {AboutService} aboutService
   * @param {ErrorService} errorService
   */
  constructor(private aboutService: AboutService,
              protected errorService: ErrorService,
              protected quickFormService: QuickFormService) {
    super(errorService, quickFormService);
  }
  ngOnInit() {
		super.ngOnInit();
    // Refresh model in case of creation by quick form
		this.subscriptions.push(
			this.quickFormService.refresh.subscribe(
				(model: BaseModel<BaseModelInterface, {}>) => {
					if(!(model instanceof About)) return;
          if(this.multiple) {
            if (!this.model) this.model = [];
            (<About[]>this.model).push(<About>model);
          } else {
            this.model = <About>model;
          }
          this.refresh();
				}
			)
		);
	}
  /** @inheritDoc */
  protected async getList(): Promise< About[]> {
      const params = new AboutSearchParams({
          _limit: this.resultsLimit,
          _page: this.currentPage
      });
      return (await this.aboutService.list(params.toObject())).items;
  }
  /** @inheritDoc */
  protected async getOne(id: string): Promise< About> {
      return await this.aboutService.get(id);
  }
}
